import { createFileRoute } from "@tanstack/react-router";

import BehaviourOrganizationDetail from "../pages/BehaviourOrganizations/BehaviourOrganizationDetail";
import { RequireAuth } from "../utils/RequireAuth";

export const Route = createFileRoute("/_shell/behaviour-studio/$orgId")({
  component: BehaviourOrganizationDetailRoute,
});

function BehaviourOrganizationDetailRoute() {
  return (
    <RequireAuth require="adminOrLimitedAdmin">
      <BehaviourOrganizationDetail />
    </RequireAuth>
  );
}
